import { type LocationQueryRaw, type RouteParamsRawGeneric, useRouter } from 'vue-router'

export const useRoutePath = () => {
  const router = useRouter()

  function getPathByName(routeName: string, params?: RouteParamsRawGeneric, query?: LocationQueryRaw) {
    return router.resolve({
      name: routeName,
      params: params,
      query: query,
    }).path || ''
  }

  function getFullPathByName(routeName: string, params?: RouteParamsRawGeneric, query?: LocationQueryRaw) {
    return router.resolve({
      name: routeName,
      params: params,
      query: query,
    }).fullPath || ''
  }

  function getPathFromLink(link: string) {
    return link.split(/[?#]/)[0].replace(/\/$/, '')
  }

  return { getPathByName, getFullPathByName, getPathFromLink }
}
